/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { dataUrlToObjectUrl } from 'unattended-showing/helpers/file-utils';

import type Appointment from 'unattended-showing/models/appointment';
import type ContextModel from 'unattended-showing/models/context';
import type LocationModel from 'unattended-showing/models/location';
import type Ajax from 'unattended-showing/services/ajax';

interface ReviewAndBookSignature {
    Element: HTMLDivElement;
    Args: {
        appointment: Appointment;
        context: ContextModel;
        location: LocationModel;
        targetMoveInDate: Date;
        backAction: () => void;
        nextAction: () => void;
    };
}

interface TermsPayload {
    value: string;
}

export default class ReviewAndBook extends Component<ReviewAndBookSignature> {
    @service declare ajax: Ajax;

    @tracked agreedToTermsAndConditions = false;

    /**
     * Check if the Book Tour button should be disabled.
     */
    get bookTourDisabled(): boolean {
        return (
            this.args.context.hasTermsAndConditions &&
            !this.agreedToTermsAndConditions
        );
    }

    /**
     * Opens a new tab for the terms and conditions.
     */
    @action async openTermsAndConditions(): Promise<void> {
        const context = this.args.context;
        if (!context.termsAndConditionsObjectUrl) {
            const dataUrl = await this.ajax.apiRequest<TermsPayload>(
                `/fileUploads/terms/${context.systemGroupId}`
            );

            context.termsAndConditionsObjectUrl = dataUrlToObjectUrl(
                dataUrl.value
            );
        }

        window.open(
            context.termsAndConditionsObjectUrl,
            '_blank',
            'noopener noreferrer'
        );
    }
}

declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        ReviewAndBook: typeof ReviewAndBook;
    }
}
